export const getItemLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : undefined;
};

export const setItemLocalStorage = (key: string, data: object | [] | number) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const purgeCache = () => {
  const token = localStorage.getItem("vue-token");
  const idToken = localStorage.getItem("vue-id-token");
  const refreshToken = localStorage.getItem("vue-refresh-token");
  const adminVersion = localStorage.getItem("bisom_web_version");
  const lastNews = localStorage.getItem("bisom_last_new");

  localStorage.clear();

  if (token && idToken && refreshToken) {
    localStorage.setItem("vue-token", token);
    localStorage.setItem("vue-id-token", idToken);
    localStorage.setItem("vue-refresh-token", refreshToken);
    localStorage.setItem("bisom_web_version", adminVersion ?? "");
    localStorage.setItem("bisom_last_new", lastNews ?? "");
  }
  window.location.href = "/";
};
